import React from 'react';
import styles from './Audio.module.scss'
import {AudioPropsInterface} from "./Audio.props.interface";

const Audio: React.FC<AudioPropsInterface> = (
    {
        audioRef,
        src,
        type,
        fill,
        ...rest
    }) => {

    return (
        <div className={styles.container}>
            <audio ref={audioRef} src={src} {...rest}>
                <source src={src} type={type}/>
            </audio>
        </div>
    );
};
export default Audio;
